
import { defineComponent } from 'vue'

import { numberFormatAddComma } from '@/utils/commonMethods'

export default defineComponent({
  name: 'HospitalsDetailAbstract',
  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    isList: {
      type: Boolean,
      dfault: false
    },
    isNarrow: {
      type: Boolean,
      dfault: false
    }
  },

  setup() {
    return {
      numberFormatAddComma
    }
  }
})
